const en = {
  100000001:'Key information',
  100000002:'Token Name',
  100000003:'Instance creator',
  100000004:'Instance Creation Time',
  100000005:'Basic information',
  100000006:'chain/protocol',
  100000007:'Smart contract address',
  100000008:'Issue Date',
  100000009:'Total Supply',
  100000010:'Circulation Supply',
  100000011:'Market Value',
  100000012:'Info',
  100000013:'Social media information',
  100000014:'Website',
  100000015:'White Paper',
  100000016:'Blockchain explorer',
  100000017:'Project Score',
  100000018:'Ranking',
  100000019:'Top',
  100000020:'Code security',
  100000021:'Operation Performance',
  100000022:'Market Stability',
  100000023:'Governance Strength',
  100000024:'Project Health',
  100000025:'Community Trust',
  100000026:'Time Updated',
  100000027:'Security score',
  100000028:'Contract security score',
  100000029:'Risk project statistics',
  100000030:'Details of the contract code',
  100000031:'Buy Tax',
  100000032:'Sell Tax',
  100000033:'Is Honeypot',
  100000034:'Is Mintable',
  100000035:'Has Blacklist',
  100000036:'Has Whitelist',
  100000037:'Is Anti-whale',
  100000038:'Can Modify Tax',
  100000039:'Not Open Source',
  100000040:'Has Hidden Owner',
  100000041:'Can Self Destruct',
  100000042:'is Proxy Contract',
  100000043:'Can modify balance',
  100000044:'Has External Calls',
  100000045:'Can Regain Ownership',
  100000046:'Is Transfer Cooldown',
  100000047:'Is Transfer Pausable',
  100000048:'Ownership Not Renounced',
  100000049:'Is Anti-whale Modifiable',
  100000050:'Decimals Too Small',
  100000051:'Pulic Mint and Burn',
  100000052:'Burn Should Update Total Supply',
  100000053:'Burn Should Update Allowance',
  100000054:'Self Transfer Could Double The Balance',
  100000055:'Transfer More Than Balance Should Fail',
  100000056:'Allowance Not Adjusted During TransferFrom',
  100000057:'TransferFrom Should Not Use Spender Balance',
  100000058:'TransferFrom More Than Allowance',
  100000059:'BurnFrom Should update Total Supply',
  100000060:'Detect the buy tax of the token. Above 5% is considered a high tax rate',
  100000061:'Detect the sell tax of the token. Above 5% is considered a high tax rate',
  100000062:'Check if the token is a honeypot scam',
  100000063:'Check if more tokens can be minted',
  100000064:'Check if the token has a blacklist that can restrict users from swapping or transferring tokens.',
  100000065:'Check if the token has a whitelist that allows addresses to bypass any restrictions',
  100000066:'Check if the token has anti whale mechanisms',
  100000067:'Check if the token has a tax and the tax can be modified by privileged roles',
  100000068:'Check if the token has been verified on blockchain explorer',
  100000069:'Check if the token has a hidden owner that can manipulate the contract, even if ownership appears to have been renounced',
  100000070:'Check if the token can self-destruct',
  100000071:'Check if the token is a proxy contract that delegates function calls to an implementation contract',
  100000072:'Check if the token balance can be modified by privileged roles',
  100000073:'Check if the token calls external contracts',
  100000074:'Check if the token has a backdoor to regain ownership',
  100000075:'Check if the token has a transfer cooldown mechanism',
  100000076:'Check if trade of the token can be paused by privileged roles',
  100000077:'Check if the owner privilege has been renounced',
  100000078:'Check if the anti whale mechanisms of the token can be modified by privileged roles',
  100000079:'Check if the return value of `decimals()` function is greater than or equal to 5',
  100000080:'Check if calling `mint()` and `burn()` functions as random users will revert',
  100000081:'Check if calling the `burn()` function will update the `totalSupply` correctly',
  100000082:"Check if calling the `burnFrom()` function will update the allowance correctly",
  100000083:"Check if calling `transfer()` function with the recipient the same as the transaction sender will increase the sender's balance",
  100000084:'Check if calling `transfer()` function with an amount more than the balance will fail',
  100000085:"Check if the allowance of the spender are updated accordingly after calling `transferFrom()` function",
  100000086:"Check if calling `transferFrom()` function will use the balance of the spender",
  100000087:"Check if the allowance is updated correctly after calling `transferFrom()`, or if the transaction reverts if the amount is invalid",
  100000088:"Check if calling the `burnFrom()` function will update the `totalSupply` correctly",
  100000089:'Check if mint authority exists',
  100000090:'Check if freeze authority exists',
  100000091:'Reviews whether the metadata can be changed',
  100000092:'Critical',
  100000093:'Major',
  100000094:'Medium',
  100000095:'Minor',
  100000096:'Informational',
  100000097:'Mint Authority has been revoked',
  100000098:'Freeze Authority has been revoked',
  100000099:'Can change metadata',

  100000100:'Your annual report is being generated…',
  100000101:'Welcome to',
  100000102:'Your 2024 review',
  100000103:'I’m your personal guide',
  100000104:'here to take you through the footprints of your 2024 journey',
  100000105:'Open report',
  100000106:'{num} days ago, the wheels of fate started turning.',
  100000107:'{userName} Our story begins here.',
  100000108:'Together, we ran toward a shared dream.',
  100000109:'Investment Stars',
  100000110:'Annual Wallet Overview - Total Yield Rate',
  100000111:'You are ahead of  <em class="normal bold" style="color: #2AFF0A;">{percentage}</em> of users',
  100000112:'In the past year, we experienced the <em class="normal bold" style="color: #FFF;">FOMO</em> that inscriptions brought, and enjoyed the joy of <em class="normal bold" style="color: #FFF;">meme surge</em> . Now, let\'s dive into your memories together.',
  100000113:'Star Trader',
  100000114:'Total Number of Trades in 2024',
  100000115:'Cumulative Trade Amount($)',
  100000116:'You’ve surpassed <em class="normal bold" style="color: #FFC72B;">{percentage}%</em> of users.',
  100000117:'This is not just a numerical achievement but also a badge of your vision and wisdom.',
  100000118:'Every trade is a step toward Web3.0.',
  100000119:'Rising Star',
  100000120:'Bitcoin’s largest drop in 2024 reached <em class="normal">34%</em>. Market corrections are the norm, and your investment performance is only a phase—great potential lies ahead!',
  100000121:'Steady Investor',
  100000122:'Every observation and wait was to prepare for a more precise moment. We look forward to seeing your investment and profit miracles in 2025.',
  100000123:'Most Traded Token in 2024',
  100000124:'What you hold onto, echoes back.',
  100000125:'Your focus and effort have already shone through in your trading results.',
  100000126:'Bitcoin’s Performance on SuperEx in 2024',
  100000127:'Your Bitcoin Price Change in 2024',
  100000128:'Congratulations on growing your assets! Keep up the momentum in the coming year.',
  100000129:'In 2024, you didn’t hold Bitcoin.',
  100000130:'Outstanding Investor',
  100000131:'Steady Investor',
  100000132:'Learning Investor',
  100000133:'Your Main Market Trading Data',
  100000134:'All earnings($)',
  100000135:'Annualized return (%)',
  100000136:'Profit ranking (%)',
  100000137:'Your futures trading data',
  100000138:'Your trading strategy showcases your wisdom—thank you for choosing to partner with us!',
  100000139:'Setting Sail for the Future',
  100000140:'Not only have you kept up with the trends, but you are also a trendsetter! You launched coins in the free zone <em class="normal bold" style="color: #FFF;">{num1}</em> times and traded <em class="normal bold" style="color: #FFF;">{num2}</em> times. You, who likes innovative products, are the true adventurer!',
  100000141:'Super Social Star',
  100000142:'Thank you for bringing <em class="normal bold" style="color: #FFF;">{num}</em> new users to our platform. Your referrals have driven our growth. We look forward to more like-minded individuals joining us on the Web3.0 journey.',
  100000143:'Rising Social Star',
  100000144:'SuperEx’s <em class="normal bold" style="color: #FFF;">{num}</em> users have earned up to 40% in trading commissions by inviting friends. If you missed out in 2024, don’t worry—seize the chance in 2025.',
  100000145:'Share your annual highlights with your community, encourage more people to join us, and unlock exclusive rewards as you explore the crypto world together!',
  100000146:'Invite a friend to get a reward worth 10 USDT!',
  100000147:'Share Report',
  100000148:'View Again',
  100000149:'In 2024, you were known on SuperEx as',
  100000150:'You outperformed platform users:',
  100000151:'Main market spot trading APY:',
  100000152:'Contract APY',
  100000153:'This year, I am an investment legend!',
  100000154:'Referral Code: {InviteCode}',
  100000155:'SuperEx.com - Web3.0 intercambio de criptomonedas',
  100000156:'Steady wins, strength revealed!',
  100000157:'This year experience gained, next year will be even better!',
  100000158:'Did you know?',
  100000159:'SuperEx\'s Spot Free Zone is the world\'s hottest and most promising Meme coin trading platform.',
  100000160:'In 2024, SuperEx will add <em class="normal bold" style="color: #FFF;">{num}</em> new users as a new family.',
  100000161:'Your 2024 review and the 2025 journey toward 1000x returns is about to begin.',
  100000162:'This is a letter from seasoned SuperEx members, sharing their exciting news from 2024.',
  100000163:'@To*** successfully purchased 1 BTC with 1 USDT, achieving a return of <em class="normal bold" style="color: #FFF;font-size:0.7rem">9,958,800%</em>.',
  100000164:'@1o*** obtained 1 ETH with 1 USDT, achieving a return of <em class="normal bold" style="color: #FFF;font-size:0.7rem">487,000%</em>.',
  100000165:'@we*** obtained an iPhone 15 with 1 USDT, achieving a return of <em class="normal bold" style="color: #FFF;font-size:0.7rem">92,800%</em>.',
  100000166:'And there’s even more to celebrate…',
  100000167:'Small investments, big returns—the ever-evolving opportunities make every participation full of surprises!',
  100000168:'Spot, futures, finance…',
  100000169:'The letter is long, so let’s keep reading.',
  100000170:'Cumulative first issuance of <span class="inline-block relative bold" style="color: #FFFFFF;font-size:1rem">150+</span> tokens,Superex continues to create more opportunities for users.',
  100000171:'Annual Wallet Overview Account Cumulative P&L Rate',
  100000172:'Wallet Overview Account Annual Profit and Loss Amount <em class="normal bold {classNum}">{num}</em>',
  100000173:'You are ahead of <em class="normal bold" style="color: #FFF;font-size:1rem">{percentage}%</em> of users. Your investment strategy wisdom is impressive.',
  100000174:'2025-SuperEx',
  100000175:'The path to wealth',
  100000176:'is waiting for you to unlock.',
  100000177:'Hi! I\'m a new friend of SuperEx.',
  100000178:'Join SuperEx, Explore Endless Possibilities, Register to Enjoy New User Benefits.',
  100000179:'User @vb*** participated in spot trading for $ATOM, achieving a cumulative return of nearly <em class="normal bold" style="color: #FFF;font-size:0.7rem">10,400%</em>.',
  100000180:'User @xi*** participated in spot trading for $PIPE, achieving a cumulative return of nearly <em class="normal bold" style="color: #FFF;font-size:0.7rem">7,400%</em>.',
  100000181:'User @09*** participated in spot trading for $ATH, achieving a cumulative return of nearly <em class="normal bold" style="color: #FFF;font-size:0.7rem">3,500%</em>.',
  100000182:'We look forward to witnessing your first trade in the Web3 world, starting a new exciting chapter!',
  100000183:'1 USD, Super_Start, 1000+ spot pairs, 150X leverage, 1000X inscriptions…',
  100000184:'A variety of high-yield sections await your exploration!',
  100000185:'Ups and downs come and go. Faith stands the test of time.',
  100000186:'Navigate the waves. Witness the value unfold.',
  100000187:'Your 2024 annual report has not been generated yet. Start your trading journey for the new year, engage more, and unlock your exclusive summary for the next year!',
  100000188:'The 2024 cryptocurrency annual story is waiting for you to review! Relive the highlight moments of 2024 with SuperEx, come and share your exclusive moments! ',
  100000189:'The 2024 cryptocurrency annual story is waiting for you to review!',
  100000190: 'Open SuperEx APP to view the 「Annual Report」',
  100000191: '{year}-{month}-{day} (UTC)',
  100000192: '',
  100000193: '',
  100000193: '',
}
export default en


// WEBPACK FOOTER //
// ./src/i18n/langs/languageAllen/en.js